import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LegalAndPrivacyContext } from "../context/LegalAndPrivacyContext";
import { useQuery } from "../utils/useQuery";
const useGoBack = () => {
  const { setCurrentPage } = useContext(LegalAndPrivacyContext);
  const navigate = useNavigate();
  const query = useQuery();

  const onClickHandler = () => {
    navigate(-1);
    const queryName = query?.get("name");
    if (queryName) {
      setCurrentPage(queryName);
    }
  };
  return { onClickBack: onClickHandler };
};
export default useGoBack;
